<template>
  <a-locale-provider :locale="zh_CN">
    <a-modal
      centered
      :maskClosable="false"
      title="挂账客户"
      v-model="customerModal"
      width="60%"
      @ok="onSubmitCustomer"
      @cancel="onCancleCustomer"
      :confirmLoading="confirmLoading"
    >
      <div style="text-align: right;margin-bottom: 10px;">
        <label class="headSearch">关键字：</label>
        <a-input
          style="width: 200px"
          placeholder="名称、简称"
          v-model="search.name"
        />
        <a-button
          style="margin-left:20px"
          type="primary"
          @click="searchCustomer"
          >查询</a-button
        >
      </div>
      <data-grid
        ref="dataGridCustomer"
        :columns="customerColumns"
        api="Customer_OfferCreditCustomerList"
        v-model="customerData"
        :params="customerParams"
        :pagination="true"
        bordered
        style="height: 400px;overflow: auto;"
      >
      </data-grid>
    </a-modal>
  </a-locale-provider>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import { DataGrid } from "@/components/dataGrid";
export default {
  name: "AccontsReceManage_OnAccount",
  components: { DataGrid },
  props: {
    ReceivableId: {
      type: String,
      default: ""
    },
    update: {
      type: Function
    }
  },
  data() {
    return {
      zh_CN,
      search: { keyword: "", name: "" },
      customerModal: true,
      customerData: [],
      customerParams: {},
      customerColumns: [
        {
          title: "序号",
          width: "8%", //宽度
          align: "center", //对齐方式
          type: "indexcolumn" // 类型，indexcolumn = 序号
        },
        {
          title: "名称",
          dataIndex: "Name",
          width: "20%"
        },
        {
          title: "简称",
          dataIndex: "ShortName",
          width: "20%"
        },
        {
          title: "单次限额",
          dataIndex: "SingleTimeLimit",
          width: "20%",
          align: "right"
        },
        {
          title: "总限额",
          dataIndex: "TotalLimit",
          width: "20%",
          align: "right"
        }
      ],
      confirmLoading: false
    };
  },
  created() {},
  methods: {
    onSubmitCustomer() {
      const _this = this;
      let row = _this.$refs.dataGridCustomer.getSelected();
      if (!row) {
        _this.$message.info("请先选择一条数据！");
        return false;
      }
      var postData = { CustomerId: row.Id, ReceivableId: _this.ReceivableId };
      this.confirmLoading = true;
      _this
        .$post("RecVa_Transfer", postData)
        .then(() => {
          _this.$emit("update");
          this.confirmLoading = false;
          _this.customerModal = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    onCancleCustomer() {
      this.customerModal = false;
    },
    searchCustomer() {
      this.customerParams = { Name: this.search.name };
    }
  }
};
</script>
